module.exports = __webpack_public_path__ + "media/images/help/line/eyecatch-point-1-d5b453743775bda9a34040aeb5136ad2.jpg";